import DashboardList from "./dashboardList";
export default DashboardList;
